import React from 'react';
import StreamForm from './StreamForm';

const StreamEdit: React.FC = () => {
  return <StreamForm isEdit={true} />;
};

export default StreamEdit; 